import * as actionTypes from '../redux/actionTypes';

const initialState = {
  directions: [],
  todaysDirections: [],
  googleDirections: null,
  todaysGoogleDirections: null,
  durations: [],
  todaysDurations: [],
  origin: [],
  todaysOrigin: [],
  cancelledDirections: [],
  profileDurations: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MAP_DIRECTIONS:
      return { ...state, directions: action.data };
    case actionTypes.MAP_TODAYS_DIRECTIONS:
      return { ...state, todaysDirections: action.data };
    case actionTypes.MAP_GOOGLE_DIRECTIONS:
      return { ...state, googleDirections: action.data, cancelledDirections: action.cancelledDirections };
    case actionTypes.MAP_TODAYS_GOOGLE_DIRECTIONS:
      return { ...state, todaysGoogleDirections: action.data };
    case actionTypes.MAP_DURATIONS:
      return { ...state, durations: action.data };
    case actionTypes.MAP_PROFILE_DURATIONS:
      return { ...state, profileDurations: action.data };
    case actionTypes.MAP_TODAYS_DURATIONS:
      return { ...state, todaysDurations: action.data };
    case actionTypes.MAP_ORIGIN:
      return { ...state, origin: action.data };
    case actionTypes.MAP_TODAYS_ORIGIN:
      return { ...state, todaysOrigin: action.data };
    default:
      return state;
  }
};
